export var SET_LOADER = 'SET_LOADER';
export var setLoader = function (isLoading) { return ({
    type: SET_LOADER,
    data: isLoading,
}); };
